import { todayISO } from "./api";
import { CLOSED_STATUSES, ENQ_STATUSES, LEAD_SOURCES, TRIP_TYPES } from "./constants";

export const statusOf = (v) => ENQ_STATUSES.find((s) => s.value === v) || ENQ_STATUSES[0];
export const sourceLabel = (v) => LEAD_SOURCES.find((s) => s.value === v)?.label || "Website";
export const tripLabel = (v) => TRIP_TYPES.find((t) => t.value === v)?.label || "";

export const paxText = (l) => {
  const a = l.adults || l.guests;
  return `${a} adult${a === 1 ? "" : "s"}${l.children ? ` + ${l.children} child${l.children === 1 ? "" : "ren"}` : ""}`;
};

export const followState = (l) => {
  if (!l.follow_up_date || CLOSED_STATUSES.includes(l.status)) return null;
  const t = todayISO();
  return l.follow_up_date < t ? "overdue" : l.follow_up_date === t ? "today" : "upcoming";
};
export const isDue = (l) => ["overdue", "today"].includes(followState(l));

const STATUS_ORDER = Object.fromEntries(ENQ_STATUSES.map((s, i) => [s.value, i]));
export const SORTS = [
  { value: "created_desc", label: "Newest enquiry" }, { value: "created_asc", label: "Oldest enquiry" },
  { value: "travel_asc", label: "Travel date (soonest)" }, { value: "travel_desc", label: "Travel date (latest)" },
  { value: "stage", label: "Lead stage" }, { value: "followup", label: "Follow-up date" },
];
const cmp = (a, b) => (a || "~").localeCompare(b || "~");
export const sortLeads = (list, by) => [...list].sort({
  created_desc: (a, b) => cmp(b.created_at, a.created_at), created_asc: (a, b) => cmp(a.created_at, b.created_at),
  travel_asc: (a, b) => cmp(a.travel_date, b.travel_date), travel_desc: (a, b) => cmp(b.travel_date || "", a.travel_date || ""),
  stage: (a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status] || cmp(b.created_at, a.created_at),
  followup: (a, b) => cmp(`${a.follow_up_date}${a.follow_up_time}`, `${b.follow_up_date}${b.follow_up_time}`),
}[by]);

export const followText = (l) => `${l.follow_up_date ? new Date(`${l.follow_up_date}T00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : ""}${l.follow_up_time ? `, ${l.follow_up_time}` : ""}`;

export const tomorrowISO = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().split("T")[0];
};

export const leadWaText = (l) => `Hi ${l.name}, thank you for your Andaman enquiry with Ocean Wings Travel${l.package_name ? ` for ${l.package_name}` : l.trip_type ? ` (${tripLabel(l.trip_type) || l.trip_type})` : ""}.`;

const CSV_COLS = [["Received", "created_at"], ["Name", "name"], ["Phone", "phone"], ["WhatsApp", "whatsapp"], ["Email", "email"], ["Travel date", "travel_date"],
  ["Quotation amount", "quotation_amount"], ["Booking status", "booking_status"],
  ["Adults", "adults"], ["Children", "children"], ["Destination", "destination"], ["Budget", "budget"], ["Requirement", "trip_type"], ["Package", "package_name"], ["Status", (l) => statusOf(l.status).label],
  ["Follow-up date", "follow_up_date"], ["Follow-up time", "follow_up_time"], ["Source", (l) => sourceLabel(l.source)], ["Source page", "source_page"], ["UTM campaign", "utm_campaign"],
  ["Message", "message"], ["Notes", "notes"]];

export const downloadLeadsCsv = (leads) => {
  const cell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const rows = [CSV_COLS.map(([h]) => cell(h)).join(","),
    ...leads.map((l) => CSV_COLS.map(([, k]) => cell(typeof k === "function" ? k(l) : l[k])).join(","))];
  const url = URL.createObjectURL(new Blob(["\ufeff" + rows.join("\n")], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `ocean-wings-leads-${todayISO()}.csv`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
